import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/shared/libs/queryClient";
import { fetchCollectionErrors } from "@/api/collectionErrors";
import type { CollectionsErrorsDateRange } from "@/types/collection-types";

/**
 * 수집 오류 조회 Query Hook
 */
export function useCollectionErrorsQuery(dateRange: CollectionsErrorsDateRange = "today") {
  return useQuery({
    queryKey: queryKeys.collectionErrors.errors(dateRange),
    queryFn: () => fetchCollectionErrors(dateRange),
    placeholderData: (prev) => prev,
  });
}
